module.exports = __webpack_public_path__ + "img/newchok-icon.77c07b6d.png";